module.exports = __webpack_public_path__ + "img/border_Ring3.05756222.svg";